import {
  PROJECTS_FILTER_FETCH_STARTED,
  PROJECTS_FILTER_FETCH_SUCCEEDED,
  PROJECTS_FILTER_FETCH_FAILED,
  PROJECTS_FILTER_SET_FILTER,
  PROJECTS_FILTER_CLEAR,
  PROJECTS_FILTER_SELECTED_DATA_FETCH_SUCCEEDED
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  projects: [],
  users: [],
  devices: [],
  error: null,
  page: 1,
  itemsPerPage: 50,
  order: 'asc',
  orderBy: 'parent',
  pages: 0,
  filter: [],
  selectedFilter: [],
  filterBy: 'title'
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case PROJECTS_FILTER_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case PROJECTS_FILTER_FETCH_SUCCEEDED:
      const { projects, users, devices } = action.payload;
      return {
        ...state,
        status: statuses.succeeded,
        projects,
        users,
        devices,
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case PROJECTS_FILTER_FETCH_FAILED:
      return { ...state, status: statuses.failed, users: [], error: action.error };
    case PROJECTS_FILTER_SET_FILTER:
      return { ...state, filter: action.payload };
    case PROJECTS_FILTER_SELECTED_DATA_FETCH_SUCCEEDED:
      return {
        ...state,
        selectedFilter: action.payload
      };
    case PROJECTS_FILTER_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
